const LIGATURES = { '\u0153': 'oe', '\u00e6': 'ae', '\u00df': 'ss' };

// Must stay identical to fold() in cloudFunctions/download_publications.py.
export function fold(text) {
  return text
    .toLowerCase()
    .replace(/[\u0153\u00e6\u00df]/g, (c) => LIGATURES[c])
    .normalize('NFD')
    .replace(/[\u0300-\u036f]/g, '')
    .replace(/ue/g, (match, offset, whole) => (offset > 0 && 'aeiouq'.includes(whole[offset - 1]) ? match : 'u'))
    .replace(/ae/g, 'a')
    .replace(/oe/g, 'o');
}

export function searchTokens(text) {
  return fold(text).match(/[0-9a-z]+(?:[-./_][0-9a-z]+)*/g) || [];
}
